<template>
    <div v-if="getView()" class="menu-wrapper">
        <a href="#"
           :href="getUrl"
           target="_blank"
        >
            <i :class="iconClass()"></i>
            <span class="pd">&nbsp;&nbsp;{{ getView() }}</span>
        </a>
    </div>
    <span v-else>{{ getValue() }}</span>
</template>

<script>

import UrlResolver from "../../services/UrlResolver";
import router from './../../router'

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
            default: function() {
                return {
                    stateIndex: null
                }
            }
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {
            menuItems: {},
        };
    },
    computed: {
        getUrl() {
            let state = JSON.parse(this.row[this.config.stateIndex] || '{}') || {};

            return UrlResolver.resolveUrl(this.getValue(), this.row, {}, state);
        },
    },
    created() {
        this.menuItems = this.indexMenu();
    },
    methods: {
        getValue() {
            return this.row[this.column.data];
        },
        getView() {
            if (this.menuItems[this.getValue()]) {
                return this.menuItems[this.getValue()].label;
            }

            return '';
        },
        iconClass() {
            if (this.menuItems[this.getValue()]) {
                return this.menuItems[this.getValue()].iconClass;
            }

            return '';
        },
        indexMenu() {
            let res = {};
            router.app.$menu.forEach(v => {
                res[v.name] = {
                    label: v.label,
                    iconClass: v.iconClass,
                };
            });

            return res;
        },
    }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// RouterViewComponent.vue?69014320